import * as api from '../dealerApi';
import {
    AddDealerPowerAssessment,
    dealerActionCreators,
    DealerActionKeys,
    IPowerAssessment
    } from '..';
import { call, put, takeEvery } from 'redux-saga/effects';
import { IEntityWithMessages } from '../../../services/HttpService';
import { uiActionCreators } from '../../ui';

function* addDealerPowerAssessmentSaga(action: AddDealerPowerAssessment) {
  yield put(uiActionCreators.showSpinnerDialog());
  try {
    const response: IEntityWithMessages<IPowerAssessment> = yield call(api.addPowerAssessment, action.payload);

    if (!response.error && response.value) {
      yield put(dealerActionCreators.setPowerAssessments([response.value]));
    }
    yield put(uiActionCreators.hidePowerAssessmentDialog());
  } catch {
    //
  }
  yield put(uiActionCreators.hideSpinnerDialog());
}

export function* watchAddDealerPowerAssessment() {
  yield takeEvery(DealerActionKeys.ADD_DEALER_POWER_ASSESSMENT, addDealerPowerAssessmentSaga);
}
